import { Link } from "react-router-dom";
import { useLeadForm } from "@/components/lead/LeadForm";
import { site } from "@/config/site";
import { SEO } from "@/components/site/SEO";

export default function NotFound() {
  const { openForm } = useLeadForm();
  return (
    <>
      <SEO title="Page Not Found | My Blinds Company" description="The page you're looking for doesn't exist." path="/404" />
      <section className="py-24 sm:py-32 text-center bg-warm-50">
        <p className="font-serif italic text-7xl text-warm-300">404</p>
        <h1 className="mt-4 font-serif text-3xl sm:text-4xl text-slate-900 tracking-tight">
          This page has been drawn closed
        </h1>
        <p className="mt-4 text-base text-slate-600 max-w-md mx-auto">
          The page you're looking for doesn't exist — but your windows still
          deserve attention.
        </p>
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
          <button
            type="button"
            data-testid="notfound-book-btn"
            onClick={() => openForm({ source: "404_page" })}
            className="rounded-full bg-navy-900 px-8 py-4 text-sm font-semibold text-white hover:bg-navy-800 transition-colors"
          >
            {site.primaryCTA}
          </button>
          <Link
            to="/"
            data-testid="notfound-home-link"
            className="rounded-full border border-navy-900/25 bg-white px-8 py-4 text-sm font-semibold text-navy-900 hover:bg-navy-900 hover:text-white transition-colors"
          >
            Back to Home
          </Link>
        </div>
      </section>
    </>
  );
}
